import React from "react";
import cn from "classnames";
import styles from "./Advantages.module.sass";
import ScrollParallax from "../ScrollParallax";

const items = [
  {
    title: "You can be a legendary olympic medalist",
    image: "/images/content/big-medal.png",
    image2x: "/images/content/big-medal@2x.png",
  },
  {
    title: "The more skilled Boxe trainer in Town",
    image: "/images/content/gloves-circle.png",
    image2x: "/images/content/gloves-circle@2x.png",
  },
  {
    title: "Or even a health specialist. We have a place for you :)",
    image: "/images/content/heart-2.png",
    image2x: "/images/content/heart-2@2x.png",
  },
];

const Advantages = () => {
  return (
    <div className={cn("section-bg", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.head}>
          <div className={cn("h2", styles.title)}>
            Want to be a pro Teacher?
          </div>
          <div className={styles.info}>
            If you are amazing on something, anything, fill out our application form to be eligible to be our new pro Teacher
          </div>
        </div>
        <div className={styles.list}>
          {items.map((x, index) => (
            <ScrollParallax className={styles.item} key={index}>
              <div className={styles.preview}>
                <img srcSet={`${x.image2x} 2x`} src={x.image} alt="Equipment" />
              </div>
              <div className={styles.subtitle}>{x.title}</div>
            </ScrollParallax>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Advantages;
